import React from 'react';
import {
  Paper,
  Typography,
  TextField,
  Box,
  Button,
  CircularProgress,
  MenuItem
} from '@mui/material';

const CredentialsForm = ({
  credentials,
  setCredentials,
  onSubmit,
  databaseType,
  setDatabaseType,
  loading,
  submitLabel = 'Submit',
  onCancel,
  additionalButtons,
}) => {
  const { alias, host, port, database, username, password } = credentials;

  // include databaseType in the form‐valid check
  const isFormValid = Boolean(
    databaseType &&
    alias &&
    host &&
    port &&
    database &&
    username &&
    password
  );

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid && !loading) onSubmit();
  };

  const types = [
    { key: 'postgresql', label: 'PostgreSQL' },
    { key: 'mysql',      label: 'MySQL' },
    { key: 'oracle',     label: 'Oracle' },
    { key: 'sqlite',     label: 'SQLite' },
    { key: 'sqlserver',  label: 'SQL Server' },
    // add more as needed
  ];

  return (
    <Paper elevation={3} sx={{ p: 4, m: 2 }}>
      <Typography variant="h6" gutterBottom>
        Database Credentials
      </Typography>

      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          select
          label="Database Type"
          required
          value={databaseType}
          onChange={(e) => setDatabaseType(e.target.value)}
          fullWidth
          margin="normal"
        >
          {types.map((type) => (
            <MenuItem key={type.key} value={type.key}>
              {type.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          required
          label="Alias (Display Name)"
          name="alias"
          value={alias}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          required
          label="Host"
          name="host"
          value={host}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          required
          label="Port"
          name="port"
          value={port}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          required
          label="Database Name"
          name="database"
          value={database}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          required
          label="Username"
          name="username"
          value={username}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          required
          label="Password"
          name="password"
          type="password"
          value={password}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={loading || !isFormValid}
          >
            {loading ? <CircularProgress size={24} /> : submitLabel}
          </Button>

          {onCancel && (
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
          )}

          {additionalButtons}
        </Box>
      </Box>
    </Paper>
  );
};

export default CredentialsForm;
